import { render, staticRenderFns } from "./GroupGrid.vue?vue&type=template&id=49956e73&"
import script from "./GroupGrid.vue?vue&type=script&lang=ts&"
export * from "./GroupGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports